// Registry for slots and their observers
const observerRegistry = new Map<Element, IntersectionObserver>();

export const createIntersectionObserver = (
	adSlotElement: Element,
	onInView: () => void,
	onOutView: () => void,
): {
	observer: IntersectionObserver;
	observerRegistry: Map<Element, IntersectionObserver>;
} => {
	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
					onInView();
				} else {
					onOutView();
				}
			}
		},
		{ threshold: 0.5 },
	);

	observerRegistry.set(adSlotElement, observer);

	return {
		observer,
		observerRegistry,
	};
};
